// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-34cb6ed8] .apexcharts-tooltip {\n  color: #fff;\n  font-size: 14px;\n  border-radius: 4px;\n  background: #616161e6;\n}\n[data-v-34cb6ed8] .apexcharts-datalabel-label {\n  letter-spacing: 0.1666666667em !important;\n}", ""]);
// Exports
module.exports = exports;
